import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { catchError, finalize, take, takeWhile } from 'rxjs/operators';
import moment from 'moment';
import * as toastr from 'toastr';
import { CustomModalService } from '../../../../../shared/modais/custom-modal/custom-modal.service';
import { appSettings } from '../../../../../../environments/app.setings';
import { PropostaSimulacao } from '../../../../shared/models/proposta-simulacao';
import { Parcela } from './parcela/parcela';
import { ParcelaPersonalizadaComponent } from './parcela-personalizada/parcela-personalizada.component';
import { AlterarValorComponent } from './alterar-valor/alterar-valor.component';
import { ProdutosComponent } from './produtos/produtos.component';
import { Proposta } from '../../../../shared/models/proposta';
import { AlteraTabelaComponent } from './altera-tabela/altera-tabela.component';
import { RetencaoComponent } from './retencao/retencao.component';
import { PropostaStateService } from '../../../../shared/states/proposta-state.service';
import { CreditoPessoalService } from '../../../services/cp.service';

@Component({
  selector: 'app-resultado-parcial',
  templateUrl: './resultado-parcial.component.html',
  styleUrls: ['./resultado-parcial.component.css'],
})
export class ResultadoParcialComponent implements OnInit, OnDestroy {
  @Output() next = new EventEmitter();
  @Output() previous = new EventEmitter();
  propostaSimulacao: PropostaSimulacao;
  propostaBackup: Proposta;
  form: FormGroup;
  showLoader = false;
  parcelas: Parcela[];
  parcelaMax: number;
  alive = true;

  constructor(
    private modalService: CustomModalService,
    private fb: FormBuilder,
    private state: PropostaStateService,
    private cpService: CreditoPessoalService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.initForm();
    this.simula();
  }

  ngOnDestroy() {
    this.alive = false;
    this.limparSimulacao();
  }

  private setPrimeiraParcela(simulacao: any) {
    // const diaContrato = this.propostaSimulacao.proposta.dataEmissaoContrato || new Date().getTime();
    // let primeiraParcela = moment.unix(diaContrato / 1000).add((this.propostaSimulacao.proposta.carencia || 0) + 30, 'days').unix();
    // const primeiraParcelauUNIX = moment.unix(primeiraParcela).toDate();
    // const onlyDay = +moment(primeiraParcelauUNIX).format('DD'); // 16
    // const addDays = (day): number => {
    //   const valid = [5, 10, 15, 20, 25];
    //   let nearestDay = 0;
    //   const index = valid.findIndex(e => e >= day);
    //   const result = index !== -1 ? valid.slice(index) : [];
    //   nearestDay = result[0] || 0;
    //   return (nearestDay - day);
    // };
    // const carencia = addDays(onlyDay);
    // if (carencia) {
    //   primeiraParcela = moment.unix(diaContrato / 1000)
    //     .add((this.propostaSimulacao.proposta.carencia || 0) + (30 + carencia), 'days')
    //     .unix();
    // }
    //
    // if (simulacao) {
    //   if (simulacao.hasOwnProperty('firstPaymentDate')) {
    //     if (simulacao.firstPaymentDate) {
    //       primeiraParcela = moment.unix(simulacao.firstPaymentDate / 1000 + 3 * 3600)
    //         .add(this.diasAte(moment().format('YYYY-MM-DD')), 'days')
    //         .add(carencia, 'days')
    //         .unix();
    //       const diaMes = moment.unix(primeiraParcela).format('YYYY-MM-DD');
    //       this.propostaSimulacao.proposta.carencia = this.diasAte(diaMes) - 30;
    //     }
    //   }
    // }
    //
    // this.propostaSimulacao.simulacao.primeiraParcela = primeiraParcela;
  }

  private initForm() {
    this.propostaSimulacao = new PropostaSimulacao();
    this.propostaSimulacao.proposta = this.state.getLast();
    this.propostaBackup = { ...this.propostaSimulacao.proposta };
    this.form = this.fb.group({
      valorFinanciamento: [
        `${this.propostaSimulacao.proposta.valorLiquido}`,
        Validators.required,
      ],
      quantidadeParcelas: ['', Validators.required],
    });

    this.obterDiasPagamento();
    this.form
      .get('quantidadeParcelas')
      .valueChanges.pipe(takeWhile(() => this.alive))
      .subscribe((e) => this.onChangeParcela(e));
  }

  private calculateParcelas(): void {
    this.parcelas = this.propostaSimulacao.simulacao.termsOfPayment.map(
      (term) =>
        new Parcela(
          term.period,
          term.amount,
          term.retentionFee,
          term.retention,
          term.net
        )
    );
    this.parcelaMax = this.parcelas[0].valor;
  }

  simula(): void {
    this.showLoader = true;
    this.cpService
      .newSimulacao(this.propostaSimulacao.proposta)
      .pipe(
        take(1),
        finalize(() => (this.showLoader = false)),
        catchError((error) => {
          this.propostaSimulacao.proposta = this.propostaBackup;
          this.state.setState(this.propostaBackup);
          toastr.warning(
            'Favor selecionar outra Tabela ou Alterar Valor Solicitado.',
            'Parâmetros não encontrados'
          );
          throw error;
        })
      )
      .subscribe((res) => this.handleSimulacao(res));
  }

  private handleSimulacao(simulacao: any) {
    this.propostaSimulacao.simulacao.paymentProtectionInsurances =
      simulacao.paymentProtectionInsurances || [];
    this.propostaSimulacao.simulacao.assistances = simulacao.assistances || [];
    this.propostaSimulacao.simulacao.termsOfPayment =
      simulacao.termsOfPayment || [];
    this.propostaSimulacao.simulacao.gracePeriodRange =
      simulacao.gracePeriodRange;
    this.propostaSimulacao.simulacao.periodRange = simulacao.periodRange || {};
    if (!this.propostaSimulacao.proposta.id) {
      this.propostaSimulacao.proposta.dataBaseEmissaoCalculada =
        simulacao.dataContrato;
    }
    const parcelaForm = Number(this.propostaSimulacao.proposta.qtdeParcelas);
    let parcelaSelecionada =
      this.propostaSimulacao.simulacao.termsOfPayment.filter(
        (e) => e.period === parcelaForm
      )[0];
    this.propostaSimulacao.simulacao.operation = parcelaSelecionada.operation;
    if (!parcelaSelecionada) {
      if (this.propostaSimulacao.simulacao.termsOfPayment.length === 1) {
        parcelaSelecionada = this.propostaSimulacao.simulacao.termsOfPayment[0];
      } else if (this.propostaSimulacao.simulacao.termsOfPayment.length > 1) {
        parcelaSelecionada = this.propostaSimulacao.simulacao.termsOfPayment[1];
      }
    }

    parcelaSelecionada = parcelaSelecionada || {};
    this.propostaSimulacao.proposta.qtdeParcelas = parcelaSelecionada.period;
    this.calculateParcelas();

    this.form.setValue({
      valorFinanciamento: simulacao.net,
      quantidadeParcelas: this.propostaSimulacao.proposta.qtdeParcelas || '',
    });

    const seguroDefault =
      this.propostaSimulacao.simulacao.paymentProtectionInsurances.filter(
        (seguro) => seguro.selected
      )[0];
    if (seguroDefault) {
      this.propostaSimulacao.proposta.seguro = seguroDefault.id;
    } else {
      this.propostaSimulacao.proposta.seguro = 0;
    }

    const assistenciaDefault =
      this.propostaSimulacao.simulacao.assistances.filter(
        (assistencia) => assistencia.selected
      )[0];
    if (assistenciaDefault) {
      this.propostaSimulacao.proposta.assistencia = assistenciaDefault.id;
    } else {
      this.propostaSimulacao.proposta.assistencia = 0;
    }

    this.state.setState(this.propostaSimulacao.proposta);
    this.changeDetectorRef.detectChanges();
  }

  onAlterarValor(valorFinanciamento) {
    this.changeProposta(
      () => (this.propostaSimulacao.proposta.valorLiquido = valorFinanciamento)
    );
    this.abrirModalTabelas();
  }

  onPersonalizarParcela(form) {
    this.changeProposta(
      () =>
        (this.propostaSimulacao.proposta.qtdeParcelas = form.quantidadeParcelas)
    );
  }

  onPersonalizarTabela(tabela) {
    this.changeProposta(
      () => (this.propostaSimulacao.proposta.tabela = tabela)
    );
  }

  private changeProposta(change: () => void) {
    this.propostaBackup = { ...this.propostaSimulacao.proposta };
    change();
    this.simula();
  }

  onChangeParcela(quantidade: number) {
    if (!quantidade) {
      return;
    }

    const parcela =
      this.parcelas.filter((e) => e.numeroParcelas === quantidade)[0] ||
      this.parcelas[0];
    this.propostaSimulacao.proposta.qtdeParcelas = parcela.numeroParcelas;
    this.propostaSimulacao.proposta.valorParcela = parcela.valor;

    this.propostaSimulacao.proposta.transients.parcela = parcela;
  }

  onChangePrimeiraParcela(data: number) {
    this.changeProposta(() => {
      this.propostaSimulacao.simulacao.primeiraParcela = data;
      const diaMes = moment.unix(data).format('YYYY-MM-DD');
      const carencia = this.diasAte(diaMes);
      this.propostaSimulacao.proposta.carencia = carencia - 30;
    });
  }

  private diasAte(diaMes): number {
    const dataBaseEmissaoCalculada =
      this.propostaSimulacao.proposta.dataBaseEmissaoCalculada || 0;
    const diaMesContrato = moment
      .unix(dataBaseEmissaoCalculada / 1000)
      .format('YYYY-MM-DD');
    return Math.abs(
      Math.round(
        moment
          .duration(
            moment(`${diaMes} 03:00:00`)
              .startOf('day')
              .diff(moment(`${diaMesContrato} 03:00:00`))
          )
          .asDays()
      )
    );
  }

  private limparSimulacao() {
    this.propostaSimulacao.proposta.seguro = undefined;
  }

  onChangeProduto({ seguro, assistencia }) {
    this.changeProposta(() => {
      this.propostaSimulacao.proposta.seguro = seguro;
      this.propostaSimulacao.proposta.assistencia = assistencia;
    });
  }

  abrirModalParcelaPersonalizada() {
    console.log(this.propostaSimulacao.simulacao.periodRange);
    const periodRange = this.propostaSimulacao.simulacao.periodRange;
    const initialState = { periodRange };
    const modal = this.modalService.show(ParcelaPersonalizadaComponent, {
      ...appSettings.MODAL_PARAMS,
      initialState,
    });

    modal.content.onSave
      .pipe(takeWhile(() => modal.content.alive))
      .subscribe((form) => this.onPersonalizarParcela(form));
  }

  abrirModalAlterarValor() {
    const initialState = { proposta: this.state.getLast() };
    const modal = this.modalService.show(AlterarValorComponent, {
      ...appSettings.MODAL_PARAMS,
      initialState,
    });

    modal.content.onSave
      .pipe(takeWhile(() => modal.content.alive))
      .subscribe((valor) => this.onAlterarValor(valor));
  }

  abrirModalProdutos() {
    const modal = this.modalService.show(
      ProdutosComponent,
      appSettings.MODAL_PARAMS
    );
    modal.content.init(this.propostaSimulacao);

    modal.content.onSave
      .pipe(takeWhile(() => modal.content.alive))
      .subscribe((produto) => this.onChangeProduto(produto));
  }

  async abrirModalTabelas() {
    const tabelas = await this.listarTabelas(
      this.propostaSimulacao.proposta.valorLiquido
    );
    const proposta = this.propostaSimulacao.proposta;
    const initialState = { tabelas, proposta };
    const modal = this.modalService.show(AlteraTabelaComponent, {
      ...appSettings.MODAL_PARAMS,
      initialState,
    });

    modal.content.onSave
      .pipe(takeWhile(() => modal.content.alive))
      .subscribe((tabela) => this.onPersonalizarTabela(tabela));
  }

  private async listarTabelas(valorFinanciamento) {
    const value = await this.cpService
      .tabelas(this.propostaSimulacao.proposta.operacao.id, valorFinanciamento)
      .toPromise();
    return value;
  }

  abrirModalRetencao() {
    const modal = this.modalService.show(
      RetencaoComponent,
      appSettings.MODAL_PARAMS
    );
    modal.content.fillParcela(
      this.propostaSimulacao.proposta.transients.parcela
    );
  }

  onClickNext() {
    this.state.setState(this.propostaSimulacao.proposta);
    this.next.emit();
  }

  onClickPrevious() {
    this.previous.emit();
  }

  get valorSolicitado() {
    return this.form.get('valorFinanciamento').value * 1;
  }

  get valorDivida() {
    if (
      !this.propostaSimulacao.proposta ||
      !this.propostaSimulacao.proposta.contratoRepique
    ) {
      return 0;
    }
    return this.propostaSimulacao.proposta.contratoRepique.valores
      .valorCorrigido;
  }

  get valorLiberado() {
    if (
      !this.valorSolicitado ||
      !this.valorDivida ||
      this.valorDivida > this.valorSolicitado
    ) {
      return 0;
    }
    return this.valorSolicitado - this.valorDivida;
  }

  get simulacao() {
    return this.propostaSimulacao.proposta.id == null;
  }

  obterDiasPagamento() {
    this.cpService
      .getDiasPagamento()
      .pipe(takeWhile(() => this.alive))
      .subscribe(
        (result) =>
          (this.propostaSimulacao.simulacao.diasValidosVencimento = result.dias)
      );
  }
}
